import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./assets/scss/app.scss";
import Routes from "./routes/routes";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AbhaLinkProvider } from "./context/AbhaLinkContext";
import { GlobalContextProvider } from "./m1/GlobalDataContext/GlobalContext";

function App() {
  return (
    <GlobalContextProvider>
      <BrowserRouter>
        <AuthProvider>
          <AbhaLinkProvider>
            <Routes />
          </AbhaLinkProvider>
        </AuthProvider>
      </BrowserRouter>
    </GlobalContextProvider>
  );
}

export default App;
